//import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EditableTextarea } from "@shared/ui-kit";
import { 
    setSysPromptAC, 
    setUserPromptAC,
    getSysPrompt,
    getUserPrompt,
} from '@entities';

import "./ai-prompts.scss";

const AIPrompts = () => {
  const dispatch = useDispatch();
  const systemPrompt = useSelector(getSysPrompt);
  const userPrompt = useSelector(getUserPrompt);

  const setSystemText = (value) => {
    dispatch(setSysPromptAC(value));
  };

  const setUserText = (value) => {
    dispatch(setUserPromptAC(value));
  };

  return (
    <div className="ai-prompts">
      <div className="ai-prompts__header mb-24">
        <h5 className="subtitle mb-12">
          Editing system and user prompts messages to create AI descriptions in
          KeyHunter.
        </h5>
      </div>

      <EditableTextarea
        name="System prompt"
        textLength={10000}
        value={systemPrompt}
        onChange={setSystemText}
        tags={["{{keywords}}", "{{lang}}", "{{title}}"]}
      />

      <EditableTextarea
        name="User prompt"
        textLength={5000}
        value={userPrompt}
        onChange={setUserText}
        tags={["{{keywords}}", "{{lang}}", "{{title}}"]}
      />
    </div>
  );
};

export default AIPrompts;
